import React, { useContext } from 'react'
import { Datacenter, datadogLogs, Logger } from '@datadog/browser-logs'

enum Action {
  pageView = 'pageView',
  pageCrash = 'pageCrash',
}

const message = (log: string) => `ISS-I-Admin ${log}`

const initDDLog = () => {
  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_ID,
    datacenter: Datacenter.US,
    forwardErrorsToLogs: true,
    sampleRate: 100,
  })

  datadogLogs.logger.addContext('app', 'admin-portal')

  return datadogLogs.logger as Logger
}

const DDLogContext = React.createContext<Logger>(null)

const useDDLog = () => useContext(DDLogContext)

const DDLogProvider = DDLogContext.Provider

export { DDLogProvider, useDDLog, initDDLog, Logger, Action, message }
